import { render, staticRenderFns } from "./settings_section.vue.js?vue&type=template&id=7e264a9c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settings_section.vue?vue&type=template&id=7e264a9c"
import script from "./settings_section.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settings_section.vue?vue&type=script&lang=js"
export * from "./settings_section.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./settings_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports